import classNames from 'classnames'

import { APIDataBlueUser } from '@evertel/types'
import { formatForSelect } from '@evertel/utils'
import { PeopleSearchSelect } from '@evertel/web/ui'

interface DocumentOwnerProps {
    documentDeptId?: number
    type?: 'label' | 'dropdown'
    selectedOwner?: APIDataBlueUser | null
    onOwnerChange?: (user: APIDataBlueUser) => void
    className?: string
}

const DocumentOwnerDisplay: React.FC<DocumentOwnerProps> = ({
    documentDeptId,
    type = 'label',
    selectedOwner,
    onOwnerChange,
    className
}) => {

    const handleOwnerChange = (selectedOwner: APIDataBlueUser) => {
        if (onOwnerChange) {
            onOwnerChange(selectedOwner)
        }
    }

    if (type === 'label') {
        return (
            <div className={classNames('d-flex align-items-center', className)}>
                <span className="fw-bold me-2">Owner:</span>
                <span>
                    {selectedOwner
                        ? (selectedOwner.firstName?.trim() || selectedOwner.lastName?.trim() )
                            ? `${selectedOwner.firstName || ''} ${selectedOwner.lastName || ''}`.trim()
                            : (selectedOwner.email || selectedOwner.id || '??????????')
                        : 'No owner selected'
                    }                </span>
            </div>
        )
    }

    const formattedOwner = selectedOwner ? formatForSelect([selectedOwner], 'firstName+lastName', 'id', undefined, 'email') : []

    return (
        <div className={classNames('d-flex align-items-center me-2', className)}>
            <span className="fw-bold me-2">Owner:</span>
            <PeopleSearchSelect
                searchScope="department"
                departmentId={documentDeptId}
                selected={formattedOwner as APIDataBlueUser[]}
                onSelect={handleOwnerChange}
                placeholder="Select owner..."
                menuPlacement="auto"
                styles={{
                    container: (baseStyles ) => ({ ...baseStyles, width: '200px'}),
                    menu: (baseStyles) => ({ ...baseStyles, width: 'max-content', right: 0})
                }}
            />
        </div>
    )
}

export { DocumentOwnerDisplay }
